import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ElementCacheType } from '../../model/cache/element-cache-type.model';
import { IdNameCacheSimpleInfoBase } from '../../model/cache/id-name-simple-info.model';

@Injectable({
	providedIn: 'root'
})
export class ElementCacheService {

	protected resourceUrl: string = "/rest/publicarea/cache"
	cacheEntity: Map<number, IdNameCacheSimpleInfoBase> = new Map()
	cacheService: Map<number, IdNameCacheSimpleInfoBase> = new Map()
	cacheProcedure: Map<number, IdNameCacheSimpleInfoBase> = new Map()

	constructor(private http: HttpClient) { }

	protected cache(type: ElementCacheType): Map<number, IdNameCacheSimpleInfoBase> {
		if (type == ElementCacheType.Entity) {
			return this.cacheEntity
		}
		if (type == ElementCacheType.Service) {
			return this.cacheService
		}
		if (type == ElementCacheType.Procedure) {
			return this.cacheProcedure
		}
		return this.cacheEntity
	}

	getSimpleInfo = (simpleInfoContainers: IdNameCacheSimpleInfoBase[], type: ElementCacheType): Observable<boolean> => {
		let notFound: IdNameCacheSimpleInfoBase[] = []
		let cache = this.cache(type)
		//Update the values from the cache
		simpleInfoContainers.forEach(p => {
			let fromCache = cache.get(p.id)
			if (fromCache == null) {
				notFound.push(p)
				cache.set(p.id, p) //This is to avoid duplicated requests with the same value. 
				return
			}
			p.copy(fromCache)
		})

		if (notFound.length == 0) {
			return of(true)
		}

		return this.http.post<IdNameCacheSimpleInfoBase[]>(`${this.resourceUrl}/${type.valueOf()}`, notFound.map(p => p.id)).pipe(map(r => {
			r.forEach(p => {
				let data = simpleInfoContainers.filter(f => f.id == p.id)
				if (data.length == 0) {
					return
				}
				data.forEach(d => {
					d.copy(p)
				})
				cache.set(p.id, p)
			})
			return true
		}))
	}

	public getAllValues(type: ElementCacheType): IterableIterator<IdNameCacheSimpleInfoBase> {
		if (type == ElementCacheType.Entity) {
			return this.cacheEntity.values()
		}
		if (type == ElementCacheType.Service) {
			return this.cacheService.values()
		}
		if (type == ElementCacheType.Procedure) {
			return this.cacheProcedure.values()
		}
		return this.cacheEntity.values()
	}

}
